import { render, staticRenderFns } from "./BaseLink.vue?vue&type=template&id=6857e2c4"
import script from "./BaseLink.vue?vue&type=script&lang=js"
export * from "./BaseLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports